<template>
    <modal id="delete-acceptance-documents-modal">
        <template slot="title">Delete Signatures</template>
        <template slot="body">
            <p>All signatures on the project form groups will be removed</p>
            <ul>
                <li v-for="group in project.groups" :key="group.id" v-text="group.code"></li>
            </ul>
        </template>
        <template slot="footer">
            <a class="btn btn-default" href="#" @click="closeModal('delete-acceptance-documents-modal')">
                Cancel
            </a>
            <button class="btn btn-danger" @click="save()">Delete</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props:{
            project:{
                type: Object,
                required: true,
            }
        },

        methods:{
            save(){
                axios.delete(`/projects/${this.project.slug}/acceptance-documents`).then(response => {
                    Alert.withAction('The signatures on the project have been removed!').then(() => {
                        this.refreshPage();
                    });
                })
            }
        },

    }
</script>
